import React from 'react';
import {useQueries} from "@tanstack/react-query";
import {getRegion} from "../../../function";
import {secretApi} from "../../../api/api";

const getMatchDataAPI = (action) => {
    const changeRegion = getRegion(action.region);
    const url = `${process.env.REACT_APP_CACHE_API}match/match-cached?match_id=${action.matchId}&platform_id=${changeRegion}`
    return secretApi.get(url).then((res) => res.data);
}
const UseSllMatchQueries = ({list}) => {
    const matchList = useQueries({
        combine: (results) => {
            const removeFalseValue = results.filter((result) => result.data)
            return {
                data: removeFalseValue.map((result) => result.data),
                pending: results.some((result) => result.isPending),
            }
        },
        queries: list.map((data) => ({
            queryKey: ['match', data],
            queryFn: async () => await getMatchDataAPI({matchId: data, region: "KR"}),
            staleTime: Infinity,
        })),
    })
    return {
        matchList
    }
};


export default UseSllMatchQueries;